export const state = () => ({
  roles: [],
  currentRole: null,
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  roles: (state) => state.roles,
  currentRole: (state) => state.currentRole,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_ROLES(state, data) {
    if (data.content) {
      state.roles = data.content
      state.pagination = {
        page: data.number,
        size: data.size,
        totalElements: data.totalElements,
        totalPages: data.totalPages
      }
    } else {
      state.roles = Array.isArray(data) ? data : []
    }
  },
  SET_CURRENT_ROLE(state, role) {
    state.currentRole = role
  },
  ADD_ROLE(state, role) {
    state.roles.push(role)
  },
  UPDATE_ROLE(state, role) {
    const index = state.roles.findIndex(r => r.id === role.id)
    if (index !== -1) {
      state.roles.splice(index, 1, role)
    }
  },
  REMOVE_ROLE(state, roleId) {
    state.roles = state.roles.filter(r => r.id !== roleId)
  }
}

export const actions = {
  async fetchRoles({ commit, rootState }, { page = 0, size = 10, sortBy = 'name', direction = 'asc', schoolId = null } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      let url = '/auth/api/roles'
      const params = { page, size, sortBy, direction }
      
      // If schoolId is provided or user is not super admin, filter by school
      const currentUser = rootState.auth.user
      const userSchoolId = currentUser?.attributes?.school_id || currentUser?.school_id
      
      if (schoolId || (!rootState.auth.user?.attributes?.roles?.some(r => r.authority === 'SYSTEM_ADMIN') && userSchoolId)) {
        const targetSchoolId = schoolId || userSchoolId
        url = `/auth/api/roles/by-school/${targetSchoolId}`
      }
      
      const response = await this.$axios.get(url, { params })
      commit('SET_ROLES', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch roles')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchRole({ commit }, roleId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/roles/${roleId}`)
      commit('SET_CURRENT_ROLE', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch role')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createRole({ commit }, roleData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/roles', roleData)
      commit('ADD_ROLE', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to create role')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteRole({ commit }, roleId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete(`/auth/api/roles/${roleId}`)
      commit('REMOVE_ROLE', roleId)
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to delete role')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

